var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "parametric-openfilter",
      on: {
        click: function($event) {
          return _vm.isFilterOpen()
        }
      }
    },
    [
      _vm._v("\n    Фильтровать\n    "),
      _c(
        "svg",
        { attrs: { width: "20", height: "13", viewBox: "0 0 20 13" } },
        [
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d:
                "M6.00592 6C7.31131 6 8.42184 5.16519\n            8.83342 4H19.0355C19.5612 4 19.9873 3.55228 19.9873 3C19.9873 2.44772 19.5612 2 19.0355\n            2H8.83342C8.42184 0.834808 7.31131 0 6.00592 0C4.70053 0 3.59 0.834808 3.17843 2H0.951775C0.426124\n            2 0 2.44772 0 3C0 3.55228 0.426124 4 0.951775 4H3.17843C3.59 5.16519 4.70053 6 6.00592 6ZM20 10C20\n            9.44771 19.5739 9 19.0482 9H17.8277C17.4161 7.83481 16.3056 7 15.0002 7C13.6948 7 12.5843 7.83481\n            12.1727 9H0.96449C0.438839 9 0.0127142 9.44771 0.0127142 10C0.0127142 10.5523 0.438839 11 0.96449\n            11H12.1727C12.5843 12.1652 13.6948 13 15.0002 13C16.3056 13 17.4161 12.1652 17.8277 11H19.0482C19.5739\n            11 20 10.5523 20 10Z"
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }